module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showLoadMore) ? _c('div', {
    staticClass: "load-more"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('loadMore')))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e8681aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loadMore/LoadMore.vue
// module id = 1361
// module chunks = 1